export default Object.freeze([
    {
        name: 'Garamond',
        value: 'Garamond'
    },
    {
        name: 'Times New Roman',
        value: 'Times New Roman'
    },
    {
        name: 'Arial',
        value: 'Arial'
    }
]);
